import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CacheReportViewModel } from '@app/models';
import { LogService } from '@app/services';
import { CacheItemMetadata } from '@app/models-internal/cacheitem-metadata';

@Injectable()
export class CacheService {
  constructor(private http: HttpClient, private log: LogService) {}

  /**
   * Clears all of the server level cache.  See also: CacheController.Clear in CacheController.cs
   */
  clear() {
    return this.http.get('admin/cache/clear');
  }

  /**
   * Clear by cache key
   * @param cacheKey
   */
  public clearByCacheKey(cacheKey: string) {
    return this.http.get<CacheItemMetadata>(`admin/cache/reset/${cacheKey}`);
  }

  /**
   * Gets the metadata for a cached item
   * @param cacheKey
   * @returns
   */
  public getCacheItemMetadata(cacheKey: string) {
    return this.http.get<CacheItemMetadata>(`public/admin/cache/meta/${cacheKey}`);
  }

  /**
   * Gets a number of caches stored in the server's cache container
   */
  count() {
    return this.http.get<number>('admin/cache/count');
  }

  getSummary() {
    return this.http.get<CacheReportViewModel>('admin/cache/summary');
  }

  warmUp() {
    return this.http.get<CacheReportViewModel>('admin/system/warmup');
  }

  clearListing(listingId: number) {
    return this.http.get<string[]>(`admin/cache/listing/${listingId}/clear`);
  }

  public clearMembershipCache() {
    return this.http.get('admin/cache/membership/clear');
  }

  public clearListingSearchMapPositionCache() {
    return this.http.get('admin/cache/search-map-positions/clear');
  }
}
